import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

// 2026-10-23 (250423 피드백 #12): 매출견적서 참조 파일 리스트를 매입견적서 모듈
// (purchaseQuoteFiles.js) 재사용 없이 자체 모듈로 분리. fileAttrVal2="매출견적서"로
// 필터링해 같은 견적(qteUuid)의 매입견적서 파일과 섞이지 않게 한다.
const [
    LIST_SALES_QUOTE_FILES,
    LIST_SALES_QUOTE_FILES_SUCCESS,
    LIST_SALES_QUOTE_FILES_FAILURE,
] = createRequestActionTypes('chance/LIST_SALES_QUOTE_FILES');
export const listSalesQuoteFiles = createAction(
    LIST_SALES_QUOTE_FILES,
    (fileTyp, fileAttrVal1, fileAttrVal3, fileAttrVal2) => ({ fileTyp, fileAttrVal1, fileAttrVal3, fileAttrVal2 }),
);
const listSalesQuoteFilesSaga = createRequestSaga(
    LIST_SALES_QUOTE_FILES,
    chanceApi.getSalesQuoteFiles,
);


export function* salesQuoteFilesSaga() {
    yield takeLatest(LIST_SALES_QUOTE_FILES, listSalesQuoteFilesSaga);
}

const initialState = {
    files: null,
    error: null,
};

const salesQuoteFiles = handleActions(
    {

        [LIST_SALES_QUOTE_FILES_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            files: data.list.map((file) => ({
                id: file.fileUuid,
                fileUrl: file.fileUrl,
                fileTyp: file.fileTyp,
                fileAttrVal1: file.fileAttrVal1, //prjUuid
                fileAttrVal2: file.fileAttrVal2,
                fileAttrVal3: file.fileAttrVal3,
                fileNm: file.fileNm,
                fileDesc: file.fileDesc,
                crtNm: file.crtNm,
                crtDt: file.crtDt,
                cngNm: file.cngNm,
                cngDt: file.cngDt,
            })),
            error: null,
        }),
        [LIST_SALES_QUOTE_FILES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
    },
    initialState,
);

export default salesQuoteFiles;
